 <!--Designed & Developed by:
    Nirmal K (@cyberwizard1001)⁶
    Nitin Ravi (@nitinravi)
    Ritwik M (@ritwik-m) &
    Nalinadevi K 
 for the Ministry of Education (MOE) virtual-labs project, Govt. Of India -->

 <template>
    <main class="app">
      <div class="codebox" style="align-items: center; justify-content: center; display: flex;">
        <img src="..\assets\Image2.png" alt="class diagram" style="width: 100%; height: 100%;">
      </div>
    </main>
  </template>
      
  <script>
  
  </script>
      
      
  <style scoped>
  * {
    box-sizing: border-box;
    background-color: #F9FAFE;
  }

  
  h1,
  h2,
  p {
    font-family: sans-serif;
    color: rgb(0, 3, 40);
  }
  
  
  .codebox {
    height: 80%;
    width: 90%;
    padding: 25px;
    border-radius: 10px;
    margin: 25px;
    background-color: #F9FAFE;
    box-shadow: 2px 3px 10px 2px #D7DFFF;
  }
  
  .app {
    background-color: #F9FAFE;
    display: flex;
    justify-content: center;
    /* align-items: center; */
  }
  </style>